<hw-page-header header="{{ 'integration.log-02.header' | translate }}" class="page-header" (onBack)="goToList()">
  <div class="content float-right" *ngIf="log">
    <button *ngIf="log.queueId" (click)="resend(log.id)" nz-button nzType="primary">
      <i nz-icon nzType="sync" nzTheme="outline"></i>
      {{ 'integration.log-02.label.resend' | translate }}
    </button>
    <button *ngIf="log.queueId" (click)="stopResend(log.queueId)" nz-button nzType="secondary">
      {{ 'integration.log-02.label.stop-resend' | translate }}
    </button>
  </div>
</hw-page-header>
<nz-content class="page-content">
  <div class="page-content__container">
    <form nz-form novalidate *ngIf="log">
      <div class="flex-row">
        <div class="dashboard__container--content-column dashboard__container--flex">
          <nz-card nzTitle="{{ 'integration.log-02.label.description' | translate }}" class="dashboard__card mb-10">
            <div hw-form-row>
              <hw-form-item name="message" label="integration.log-02.label.message-id" *hwFormCol>
                <a (click)="searchByMessageId()">{{ log.messageId }}</a>
              </hw-form-item>
            </div>
            <div hw-form-row>
              <hw-form-item name="code" label="integration.log-02.divider.service" *hwFormCol>
                {{ log.service.description }} ({{ log.service.code }})
              </hw-form-item>
            </div>
            <div hw-form-row>
              <hw-form-item name="date" label="integration.log-02.label.date" *hwFormCol>
                {{ log.date | localDateTime }}
              </hw-form-item>
            </div>
            <div hw-form-row>
              <hw-form-item name="status" label="integration.log-02.label.status" *hwFormCol>
                <nz-tag [nzColor]="'green'" *ngIf="log.status === 'OK'">{{ log.status }}</nz-tag>
                <nz-tag [nzColor]="'red'" *ngIf="log.status === 'FAILED'">{{ log.status }}</nz-tag>
                <nz-tag [nzColor]="'blue'" *ngIf="log.status === 'RESENT'">{{ log.status }}</nz-tag>
                <nz-tag [nzColor]="'gray'" *ngIf="log.status === 'STOPPED'">{{ log.status }}</nz-tag>
              </hw-form-item>
            </div>
            <div hw-form-row>
              <hw-form-item name="direction" label="integration.log-02.label.direction" *hwFormCol>
                {{
                  log.direction === 'in'
                    ? log.participant.name + ' (' + log.participant.code + ') → HEDA'
                    : 'HEDA → ' + log.participant.name + ' (' + log.participant.code + ')'
                }}
              </hw-form-item>
            </div>
          </nz-card>

          <nz-card
            *ngIf="log.references && log.references.length > 0 && references"
            nzTitle="{{ 'integration.log-02.divider.references' | translate }}"
            class="dashboard__card mb-10">
            <div hw-form-row *ngFor="let reference of log.references">
              <hw-form-item
                name="description"
                [label]="
                  references[reference.resource]
                    ? (references[reference.resource].names | localName)
                    : reference.resource
                "
                *hwFormCol>
                <a
                  [routerLink]="['/integration/logs', { resource: reference.resource + '|' + reference.resourceId }]"
                  >{{ reference.resourceId }}</a
                >
              </hw-form-item>
            </div>
          </nz-card>
        </div>

        <div class="dashboard__container--content-column dashboard__container--flex pl-10">
          <nz-card
            *ngIf="log.queueId"
            nzTitle="{{ 'integration.log-02.label.resend-queue' | translate }}"
            class="dashboard__card pl-10 mb-10">
            <nz-timeline *ngIf="queueChain">
              <nz-timeline-item
                *ngFor="let queue of queueChain"
                [nzColor]="queue.id === log.queueId ? 'blue' : queue.ended ? 'gray' : 'orange'">
                <span *ngIf="queue.messageLogId && queue.id !== log.queueId">
                  <a [routerLink]="['/integration/logs/view', queue.messageLogId]">{{
                    queue.scheduled | localDateTime
                  }}</a>
                </span>
                <span *ngIf="!queue.messageLogId || queue.id === log.queueId">{{
                  queue.scheduled | localDateTime
                }}</span>

                <span *ngIf="queue.messageLogId && queue.id !== log.queueId" style="padding-left: 5px">
                  <nz-tag [nzColor]="'green'" *ngIf="queue.messageLogStatus === 'OK'">{{
                    queue.messageLogStatus
                  }}</nz-tag>
                  <nz-tag [nzColor]="'red'" *ngIf="queue.messageLogStatus === 'FAILED'">{{
                    queue.messageLogStatus
                  }}</nz-tag>
                  <nz-tag [nzColor]="'blue'" *ngIf="queue.messageLogStatus === 'RESENT'">{{
                    queue.messageLogStatus
                  }}</nz-tag>
                  <nz-tag [nzColor]="'gray'" *ngIf="queue.messageLogStatus === 'STOPPED'">{{
                    queue.messageLogStatus
                  }}</nz-tag>
                </span>
                <span *ngIf="!queue.messageLogId && !queue.ended" style="padding-left: 5px">
                  <nz-tag [nzColor]="'orange'">SCHEDULED</nz-tag>
                </span>
              </nz-timeline-item>
            </nz-timeline>
          </nz-card>
          <nz-card
            *ngIf="log.queueId && series"
            nzTitle="{{ 'integration.log-02.label.series' | translate }}"
            class="dashboard__card pl-10 mb-10">
            <nz-timeline *ngIf="currentQueueItem">
              <nz-timeline-item
                *ngFor="let queue of series"
                [nzColor]="currentQueueItem.chainId === queue.chainId ? 'blue' : 'gray'">
                <ng-template #tooltip>
                  <pre>{{ queue.params | json }}</pre>
                </ng-template>
                <span nz-tooltip [nzTooltipTitle]="tooltip">
                  {{ queue.created | localDateTime }}
                  <nz-tag
                    [nzColor]="queue.status === 'ACTIVE' ? 'orange' : queue.status === 'STOPPED' ? 'red' : 'gray'">
                    {{ queue.status }}
                  </nz-tag>
                </span>
              </nz-timeline-item>
            </nz-timeline>
          </nz-card>
        </div>
      </div>

      <hw-divider
        *ngIf="log.request.header || log.request.body"
        text="{{ 'integration.log-02.divider.request' | translate }}"></hw-divider>
      <nz-collapse>
        <nz-collapse-panel *ngIf="log.request.header" nzHeader="{{ 'integration.log-02.label.header' | translate }}">
          <div class="full-width">
            <pre>{{ log.request.header }}</pre>
          </div>
        </nz-collapse-panel>
        <nz-collapse-panel
          *ngIf="log.request.body"
          nzActive="true"
          nzHeader="{{ 'integration.log-02.label.body' | translate }}"
          [nzExtra]="cardExtra">
          <div class="full-width">
            <pre>{{ log.request.body }}</pre>
          </div>
          <ng-template #cardExtra>
            <hw-copy-button mode="icon-text" [content]="log.request.body"></hw-copy-button>
          </ng-template>
        </nz-collapse-panel>
        <nz-collapse-panel
          *ngIf="log.request.cda"
          nzActive="true"
          nzHeader="{{ 'integration.log-02.divider.request-cda' | translate }}"
          [nzExtra]="cardExtra">
          <div class="full-width">
            <pre>{{ log.request.cda }}</pre>
          </div>
          <ng-template #cardExtra>
            <hw-copy-button mode="icon-text" [content]="log.request.cda"></hw-copy-button>
          </ng-template>
        </nz-collapse-panel>
      </nz-collapse>

      <hw-divider
        *ngIf="log.response.header || log.response.body"
        text="{{ 'integration.log-02.divider.response' | translate }}"></hw-divider>
      <nz-collapse>
        <nz-collapse-panel *ngIf="log.response.header" nzHeader="{{ 'integration.log-02.label.header' | translate }}">
          <div class="full-width">
            <pre>{{ log.response.header }}</pre>
          </div>
        </nz-collapse-panel>
        <nz-collapse-panel
          *ngIf="log.response.body"
          nzHeader="{{ 'integration.log-02.label.body' | translate }}"
          [nzExtra]="cardExtra"
          [nzActive]="true">
          <div class="full-width">
            <pre>{{ log.response.body }}</pre>
          </div>
          <ng-template #cardExtra>
            <hw-copy-button mode="icon-text" [content]="log.response.body"></hw-copy-button>
          </ng-template>
        </nz-collapse-panel>
        <nz-collapse-panel
          *ngIf="log.response.error"
          nzHeader="{{ 'integration.log-02.divider.error' | translate }}"
          [nzExtra]="cardExtra"
          [nzActive]="true">
          <div class="full-width">
            <pre>{{ log.response.error }}</pre>
          </div>
          <ng-template #cardExtra>
            <hw-copy-button mode="icon-text" [content]="log.response.error"></hw-copy-button>
          </ng-template>
        </nz-collapse-panel>
      </nz-collapse>
    </form>
  </div>
</nz-content>
